// eslint-disable-next-line max-classes-per-file
import { v4 as uuid } from 'uuid';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import reduce from 'lodash/reduce';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { CategoryMap } from './QuickSearchAutosuggestConstants';

class ItemsProcessor {
  constructor(items) {
    this.items = items;
  }

  convertForView() {
    this.items = map(this.items, (item) => ({
      Typeahead: item,
      title: item.Label,
      category: CategoryMap[item.Category],
    }));
    this.items = sortBy(this.items, 'category');

    // limit to 5 per each category
    this.items = reduce(
      this.items,
      (result, item) => {
        if (!result || !result.filteredItems) {
          // eslint-disable-next-line no-param-reassign
          result.filteredItems = [];
        }
        if (result.filteredItems.filter((resultItem) => resultItem.category === item.category).length < 5) {
          result.filteredItems.push(item);
        }
        return result;
      },
      {}
    ).filteredItems;
    return this;
  }
}

class QuickSearchAutosuggestService {
  // eslint-disable-next-line class-methods-use-this
  _autosuggestFetch(query) {
    const params = {
      query: window.encodeURIComponent(query),
    };

    const requestUrl = RequestUrls.autosuggestSearch;

    return MessageBroker.send(requestUrl, params);
  }

  getAutosuggestsByQuery(query) {
    return this._autosuggestFetch(query).then((resp) => {
      const mappedResponse = resp.map((item) => {
        const { category, documentCount, graph, label, orgId, start, end, ...rest } = item;
        return {
          ...rest,
          Id: uuid(),
          Category: category,
          DocumentCount: documentCount,
          Graph: graph,
          Label: label,
          OrigId: orgId,
          End: end,
          Start: start,
        };
      });

      return new ItemsProcessor(mappedResponse).convertForView().items;
    });
  }
}

export default new QuickSearchAutosuggestService();
